import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const accountUser = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    isAdmin: z
      .boolean()
      .nullable()
      .optional()
      .describe('Is Admin - Can manage the account, members, and billing'),

    isDesigner: z
      .boolean()
      .nullable()
      .optional()
      .describe('Is Designer - Can use design tools'),

    accountId: z.number().hidden().describe('Foreign key to Account'),

    userId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    account: belongsTo('Account'),

    user: references('User'),
  })
  .describe(
    "Join between Account and User. Represents a user's membership in an account\nwith role flags controlling what they can do.",
  )
  .as('AccountUser');

export { accountUser as accountUserSchema };
